import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environmet';
import {
  ApiResponse,
  CreateUserRequest,
  PagedUsersResponse,
  UpdateUserRequest,
  User,
} from '../models/user.models';

@Injectable({
  providedIn: 'root',
})
export class UsersApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/users`;

  getUsers(
    companyId: number,
    pageNumber: number = 1,
    pageSize: number = 20,
    search?: string,
    roleId?: number,
    isActive?: boolean,
  ): Observable<ApiResponse<PagedUsersResponse>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    if (companyId > 0) {
      params = params.set('companyId', companyId.toString());
    }

    if (search) {
      params = params.set('search', search);
    }

    if (roleId !== undefined && roleId !== null && roleId > 0) {
      params = params.set('roleId', roleId.toString());
    }

    if (isActive !== undefined && isActive !== null) {
      params = params.set('isActive', isActive.toString());
    }

    return this.http.get<ApiResponse<PagedUsersResponse>>(this.baseUrl, { params });
  }

  getUser(userId: number): Observable<ApiResponse<User>> {
    return this.http.get<ApiResponse<User>>(`${this.baseUrl}/${userId}`);
  }

  createUser(payload: CreateUserRequest): Observable<ApiResponse<User>> {
    return this.http.post<ApiResponse<User>>(this.baseUrl, payload);
  }

  updateUser(userId: number, payload: UpdateUserRequest): Observable<ApiResponse<User>> {
    return this.http.put<ApiResponse<User>>(`${this.baseUrl}/${userId}`, payload);
  }

  deleteUser(userId: number): Observable<ApiResponse<string>> {
    return this.http.delete<ApiResponse<string>>(`${this.baseUrl}/${userId}`);
  }

  resetUserPassword(userId: number): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(`${this.baseUrl}/${userId}/reset-password`, {});
  }
}
